import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';

import { RemarkButton } from '@Components/IconButton';
import Remark from '@Components/Remark';
import { useDisclosure } from '@hooks/useDisclosure';

import { useNatureOfBusinessForm } from '../NatureOfBusinessFormProvider';
import { MarketingIndustryFormValues } from '../NatureOfBusinessFormProvider/types';

export const MARKET_LAST_YEAR_REMARK_ID = 'market-last-year-remark';

const MarketPolicyLastYearRemark = () => {
  const { control, getValues } = useNatureOfBusinessForm();

  const { marketingPolicyRemark: remark } =
    getValues(`marketingIndustry`) ?? ({} as MarketingIndustryFormValues);

  const [isRemarkOpen, { open, close }] = useDisclosure(!!remark);

  const marketLastYearRemarkEl = document.getElementById(
    MARKET_LAST_YEAR_REMARK_ID
  );

  const { completedSection } =
    useWatch({
      name: 'marketingIndustry',
      control,
    }) ?? ({} as MarketingIndustryFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isRemarkOpen &&
        marketLastYearRemarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              onDelete={close}
              topic="นโยบายการตลาดของผลิตภัณฑ์หรือบริการที่สำคัญในปีที่ผ่านมา"
              setOpen={open}
              fieldPath="marketingIndustry.marketingPolicyRemark"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          marketLastYearRemarkEl
        )}
    </>
  );
};

export default MarketPolicyLastYearRemark;
